export const DEFAULT_CONFIGS = {
    "seo": {
        "categories": {
            "images": {
                "alt": "SEO_IMAGE_CATEGORIES_ALT",
                "title": "SEO_IMAGE_CATEGORIES_TITLE"
            }
        },
        "games": {
            "images": {
                "alt": "SEO_IMAGE_GAME_TITLE"
            }
        }
    },
    "header": {
        "header_buttons": {
            "languages": {
                "display": false
            },
            "help": {
                "display": true
            },
            "search": {
                "display": true
            }
        },
        "top_header_right": [
            "state-cross-brand",
            "app-safezone",
            "state-selection-button",
            "app-help-button",
            "app-language-switcher"
        ],
        "top_header_left": [
            "search-box-form",
            "app-responsible-icons"
        ]
    },
    "adminBanner": {
        "enabled": false
    },
    "SDK": {
        "debug": false,
        "Integration": {
            "historyLink": "/gaming-history/",
            "gameSessionHistoryLink": "/session-history/",
        },
        "Analytics": {
            "GTMContainerID": "GTM-NTXB7CN",
            "UATrackingID": "UA-66227773-1",
            "awaitForDataLayer": "true"
        }
    },
    generalSettings: {
        showRegisterButton: true,
        gamesPreviewConfig: {
            enabledOnPC: false,
            shouldDisplayJackpot: true,
        }
    },
    miniOrbit: {
        "/cip": {
            "arenasHeaderButtons": [
                {
                    "title": "LOBBY",
                    "link": "/cip",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/my_casino_icon.png",
                },
                {
                    "title": "SLOTS",
                    "link": "/cip/slots",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/slots_icon.png",
                },
                {
                    "title": "JACKPOTS",
                    "link": "/cip/jackpots",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/jackpots_icon.png"
                },
                {
                    "title": "LIVE_CASINO",
                    "link": "/cip/live-casino",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/live_icon.png"
                },
                {
                    "title": "CASINO_GAMES",
                    "link": "/cip/casino-games",
                    "icon": "{assetsPath}/images/mini_orbit/cip/arenas_header_buttons/casino_games_icon.png"
                }
            ]
        },
        "/cis": {
            "arenasHeaderButtons": [
                {
                    "title": "LOBBY",
                    "link": "/cis",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/my_casino_icon.png",
                },
                {
                    "title": "SLOTS",
                    "link": "/cis/slots",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/slots_icon.png",
                },
                {
                    "title": "CASINO_GAMES",
                    "link": "/cis/casino-games",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/casino_games_icon.png"
                },
                {
                    "title": "LIVE_CASINO",
                    "link": "/cis/live-casino",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/live_icon.png"
                },
                {
                    "title": "JACKPOTS",
                    "link": "/cis/jackpots",
                    "icon": "{assetsPath}/images/mini_orbit/cis/arenas_header_buttons/jackpots_icon.png"
                }
            ]
        }
    },
    "theme": {
        "name": "casino888"
    },
    arenas: {
        slots: {
            advancedFilters: {
                categories: [
                    { id: "volatility", excludedFilters: [] },
                    { id: "features" },
                    { id: "hasJackpot" },
                    { id: "themes" },
                    { id: "vendors" }
                ]
            }
        },
        casinoGames: {
            advancedFilters: {
                categories: [
                    { id: "gameGroups" },
                    { id: "features" },
                    { id: "hasJackpot" },
                    { id: "vendors" }
                ]
            }
        },
        exclusive888Games: {
            advancedFilters: {
                categories: [
                    { id: "volatility" },
                    { id: "gameGroups" },
                    { id: "features" },
                    { id: "hasJackpot" },
                    { id: "themes" }
                ]
            }
        }
    }
};
